import React, { useState } from "react";
import Header from "../Header";
import Cropper from "react-easy-crop";
import { supabase } from "../../../supabase";
import { getCroppedWebp } from "./imageUtils";
import { useNavigate } from "react-router-dom";

function AddPresident() {
  const [name, setName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const navigate = useNavigate();
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedPixels, setCroppedPixels] = useState(null);
  const [loading, setLoading] = useState(false);

  const onCropComplete = (_, croppedAreaPixels) => {
    setCroppedPixels(croppedAreaPixels);
  };

  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => setImageSrc(reader.result);
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // 1️⃣ Insert form data
      const { data, error } = await supabase
        .from("presidents")
        .insert({
          name,
          from_date: fromDate,
          to_date: toDate,
        })
        .select()
        .single();

      if (error) throw error;

      const id = data.id;
      let imageUrl = null;

      // 2️⃣ Upload image ONLY if selected
      if (imageSrc && croppedPixels) {
        const webpBlob = await getCroppedWebp(imageSrc, croppedPixels);

        const filePath = `${id}.webp`;

        const { error: uploadError } = await supabase.storage
          .from("presidents")
          .upload(filePath, webpBlob, {
            contentType: "image/webp",
            upsert: true,
          });

        if (uploadError) throw uploadError;

        // 3️⃣ Get public URL
        const { data: urlData } = supabase.storage
          .from("presidents")
          .getPublicUrl(filePath);

        imageUrl = urlData.publicUrl;

        // 4️⃣ Update row with image URL
        const { error: updateError } = await supabase
          .from("presidents")
          .update({ image_url: imageUrl })
          .eq("id", id);

        if (updateError) throw updateError;
      }

      alert("President added successfully!");
      navigate(-1);
    } catch (err) {
      console.error(err);
      alert("Failed to submit data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="main-content" id="mainContent">
      <Header heading="President" />

      <form className="mt-4" onSubmit={handleSubmit}>
        <div className="row">
         <div className="col-lg-4">
            {imageSrc && (
              <div style={{ position: "relative", height: 400, marginTop: 20 }}>
                <Cropper
                  image={imageSrc}
                  crop={crop}
                  zoom={zoom}
                  aspect={3 / 4} // ✅ Portrait
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={onCropComplete}
                />
              </div>
            )}

            <label>Profile Photo (if applicable)</label>
            <input
              type="file"
              accept="image/*"
              className="form-control"
              onChange={handleImageSelect}
            />
          </div> 
          <div className="col-lg-7">
            <label>Name of the President *</label>
            <input
              className="form-control mb-2"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <div className="row">
              <div className="col-lg-6">
                <label>From Date *</label>
                <input
                  type="date"
                  className="form-control mb-2"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  required
                />
              </div>
              <div className="col-lg-6">
                <label>To Date *</label>
                <input
                  type="date"
                  className="form-control mb-2"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  required
                />
              </div>
            </div>

            <button className="btn btn-primary mt-4" disabled={loading}>
              {loading ? "Saving..." : "Submit"}
            </button>
          </div>
        </div>
      </form>
    </main>
  );
}

export default AddPresident;
